export const FEATURE_FLAGS_RECEIVED = 'FEATURE_FLAGS_RECEIVED';

const getFeatureFlags = () => (
  (dispatch) => {
    dispatch({
      type: FEATURE_FLAGS_RECEIVED,
      featureFlags: window.featureFlags,
    });
  }
);

export default getFeatureFlags;
